import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/types/database.types';

const SUPABASE_URL = "https://fwbphnqidhvsumeecpjj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZ3YnBobnFpZGh2c3VtZWVjcGpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc1MDQ0MzYsImV4cCI6MjA1MzA4MDQzNn0.rlZsihtryXywu6acxLOAdh1mw4NxIDpbVwFw9RwND9U";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);